import React from "react";
import { FiCamera } from "react-icons/fi";
import { Chip } from "./Chip";

/**
 * Body/weight readings a client attached to a message, as compact chips.
 * A metric that points at a photo proof is clickable and focuses that
 * attachment in the bubble below.
 *
 * @param {Object} props
 * @param {import('../../utils/commsAttachments').ChatMetric[]} props.metrics
 * @param {(attachmentIndex: number) => void} [props.onShowProof] - Opens the
 *   linked attachment; omit to render proof as a non-interactive hint.
 */
export const MessageMetrics = ({ metrics, onShowProof }) => {
  if (!metrics || !metrics.length) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {metrics.map((metric, i) => {
        const value =
          metric.value === null
            ? "—"
            : `${metric.value}${metric.unit ? ` ${metric.unit}` : ""}`;
        const hasProof = metric.attachmentIndex !== null;
        const label = (
          <>
            <span className="font-normal opacity-75">{metric.label}</span>
            <span className="ml-1.5 font-bold">{value}</span>
            {hasProof && (
              <FiCamera aria-hidden="true" className="ml-1.5 opacity-75" />
            )}
          </>
        );

        if (hasProof && onShowProof) {
          return (
            <button
              key={`${metric.code}-${i}`}
              type="button"
              onClick={() => onShowProof(metric.attachmentIndex)}
              aria-label={`${metric.label} ${value} — view photo proof`}
              className="rounded-lg transition-opacity hover:opacity-80"
            >
              <Chip tone="brand">{label}</Chip>
            </button>
          );
        }

        return (
          <Chip key={`${metric.code}-${i}`} tone="brand">
            {label}
          </Chip>
        );
      })}
    </div>
  );
};

export default MessageMetrics;
